/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import 'src/fonts/fonts.css'
import 'typeface-bitter'
import 'react-tippy/dist/tippy.css'